interface Environment {
  lambda: string[];
  glue: string[];
  crawler: string[];
  gitlab: string[];
  athena: string[];
}

type EnvironmentsData = Record<string, Environment>;

interface AwsMetric {
  Timestamp: string;
  Sum: number;
}

interface Resource {
  name: string;
  invocations: number;
  errors: number;
  data: AwsMetric[] | string[][];
  subtype: string;
}

type ResourcesData = Record<string, Resource[] | string | boolean>;

const resourceTypes = [
  { name: "all", color: "var(--secondary-color)" },
  { name: "lambda", color: "var(--lambda-color)" },
  { name: "glueJob", color: "var(--glue-color)" },
  { name: "glueCrawler", color: "var(--glue-color)" },
  { name: "gitlab-ci", color: "var(--gitlab-color)" },
  { name: "athena", color: "var(--athena-color)" },
];

export default resourceTypes;
export type { ResourcesData, EnvironmentsData, Resource, AwsMetric };
